export default __webpack_public_path__ + "static/media/decent-earning.f4c8fb5f.jpeg";